 const initialState = {
    replacementCarRequestsData: [], 
    loading:true
};

const replacementCarRequestsReducer = function (state = initialState, action) {
    switch (action.type) {
        case 'GET_ALLREPLACEMENT_CAR_REQUESTS': {
            return {
              ...state,
              replacementCarRequestsData: action.payload, 
              loading: false,
            };
          }
          case 'GET_ALLREPLACEMENT_CAR_REQUESTS_ERROR': {
            return {
              ...state,
              error: action.payload,
              loading: false,
            };
          }
          case 'ADD_REPLACEMENT_CAR_REQUEST':
            return {
              ...state,
              replacementCarRequestsData: [...state.replacementCarRequestsData, action.payload],
            };
          case 'UPDATE_REPLACEMENT_CAR_REQUEST':
            const updatedReplacementCarRequestsData = state.replacementCarRequestsData.map(replacementCarRequest => {
              if (replacementCarRequest.id === action.payload.id) {
                return action.payload;
              }
              return replacementCarRequest;
            });
            return {
              ...state,
              replacementCarRequestsData: updatedReplacementCarRequestsData,
            };
      default:
        return state;
    }
  };
  export default replacementCarRequestsReducer;